import MainLayout from 'layouts/MainLayout'

import styles from './AuthLayout.module.scss'

const AuthLayout = ({ children }) => (
  <MainLayout contentClassName={styles.content} authLayout>
    {children}
  </MainLayout>
)

export default AuthLayout
